import {
  Badge,
  MediaGroup,
  MediaWithViewer,
  Space,
  SubText,
} from '@procurify/ui'

import { CatalogItemIndicator } from '@webapp/components/CatalogItemIndicator'
import { OrderItemTypeTag } from '@webapp/components/OrderItemTypeTag'
import { PunchOutSupplierIcon } from '@webapp/components/PunchOutSupplierIcon'
import { useFormatMedia } from '@webapp/core/hooks/useFormatMedia'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { type ColumnTypeData } from '../../types/DataTable.types'

export const OrderItemDescriptionCell = ({
  description,
  attachments,
  isCatalogItem,
  punchOutSupplierName,
  punchOutSupplierIcon,
  sku,
  itemType,
}: ColumnTypeData['ORDERITEM_DESCRIPTION']) => {
  const intl = useProcurifyIntl()
  const formatMedia = useFormatMedia()

  return (
    <Space direction='horizontal'>
      {attachments?.[0]?.file ? (
        <div onClick={(e) => e.stopPropagation()}>
          <MediaGroup>
            <MediaWithViewer
              src={formatMedia(attachments[0].file)}
              files={attachments.map((att) => {
                return {
                  file: formatMedia(att.file),
                  name: att.name,
                }
              })}
            />
            {attachments.length > 1 ? (
              <Badge>{attachments.length}</Badge>
            ) : null}
          </MediaGroup>
        </div>
      ) : null}

      <div>
        {isCatalogItem && <CatalogItemIndicator />}{' '}
        <PunchOutSupplierIcon
          name={punchOutSupplierName}
          iconUrl={punchOutSupplierIcon}
        />{' '}
        <SubText inline bold>
          {description}
        </SubText>
        {sku && (
          <div>
            <SubText inline bold autoMargin={false}>
              {intl.formatMessage(messages.skuLabel)}: {sku}
            </SubText>
          </div>
        )}
        {!!itemType && <OrderItemTypeTag itemType={itemType} />}
      </div>
    </Space>
  )
}

OrderItemDescriptionCell.displayName = 'OrderItemDescriptionCell'
